module.exports = __webpack_public_path__ + "img/Group 1004three.5abbf240.png";